import AgreementStep from './components/AgreementStep.jsx';
import ESignApplicationContainer from './ESignApplicationContainer.jsx';

export default function ESignAgreementPage() {
  return (
    <ESignApplicationContainer>
      <AgreementStep />
    </ESignApplicationContainer>
  );
}
